import '.c{display:flex;}.ssr-plugin'
import '.h{align-items:center;}.ssr-plugin'
import '.d{justify-content:center;}.ssr-plugin'
import '.g{flex-direction:column;}.ssr-plugin'
import '.b0{background-color:var(--palette-beige-100);}.ssr-plugin'
import '.b1{min-height:calc(100vh - 12rem);}.ssr-plugin'
import '.a6{align-items:stretch;}.ssr-plugin'
import '.b2{margin-top:2rem;}.ssr-plugin'
import '.a5{margin-bottom:5rem;}.ssr-plugin'
import '.b3{max-width:77.5rem;}.ssr-plugin'
import { ReactNode } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { DashboardNavBar } from '@app/components/blocks/navbar/dashboard/DashboardNavBar'
import { ClientOnly, Head } from '@based/sdk'

export const DashboardPageLayout = ({
  gap = '1rem',
  children,
}: {
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
}) => {
  const isMobile = useMediaQuery()
  return (
    <ClientOnly>
      <Head>
        <title>CrowdBuilding - dashboard</title>
      </Head>
      <div className="c h d g b0"
      >
        <DashboardNavBar />
        <div className="b1 c g a6 b2 a5 b3"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%', // 12rem is padding + navbar height
            paddingInline: isMobile ? '1rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
